import React, { useState, useEffect } from "react";
import { ReactComponent as ArrowRightSvg } from "../logo/ArrowRight.svg";
import { CancelToken } from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useAlert } from "react-alert";
import { get} from "../common/api";

import "./CartPage.css";

export function CartPage(props) {
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  const alert = useAlert();

  const [isLoading, setIsLoading] = useState(true);
  const [itinList, setItinList] = useState(null);

 
  useEffect(() => {
    if (!auth.token) {
      alert.info(
        "Silahkan login terlebih dahulu untuk melihat page Cart."
      );
      history.push("/login");
      return;
    }

    const source = CancelToken.source();
    async function fetchData() {
      try {
        const res = await get(`https://liwat-id-backend.herokuapp.com/api/cart/show`, {
          cancelToken: source.cancelToken,
          validateStatus: (status) => {
            if (status >= 200 && status < 300) return true; // 2xx
            if (status >= 400 && status < 500) return true; // 4xx
            return false;
          },
          headers: {
            Authorization: `Token ${auth.token}`,
          },
        });
        await setItinList(
          res.status >= 200 && res.status < 300 ? res.data : []
        );
      } catch (e) {
        alert.error("Terjadi kesalahan. Silahkan coba lagi");
      }
      setIsLoading(false);
    }
    fetchData();
    return () => {
      source.cancel();
    };
  }, [auth, history, alert]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-self-center align-items-center w-100 h-100">
        <div className="spinner-border" role="status" />
      </div>
    );
  }
  
    return (
      <ItinListComponent
        itinList={itinList}
      />
    );

}

function ItinListComponent(props) {
  const { itinList} = props;
  return (
    <div className="itin-list-container">
      <div className="itin-list-container-header flex-column flex-md-row">
        <h3 className="mb-1 mb-md-2">Keranjang</h3>
      </div>
      
      {itinList.map((itinRow) => (
        <ItinRowComponent
          key={`itin-row-${itinRow.id}`}
          {...itinRow}
        />
      ))}
       <div className="d-flex justify-content-center">
         <button className="create-ticket-button primary-button">Beli Tiket</button>
        </div>

    </div>
  );
}

function ItinRowComponent(props) {
  const budget = props.budget
  var totalBudget = new Intl.NumberFormat("ID").format(budget);
  return (
    <div
      className="itin-row-container flex-md-row flex-column"
      testid="itin-row"
    >
    <label className="form-check-label itin h4">
        <input className="form-check-input"  type="checkbox"/>
      </label>
    
      <img src={props.trip.image} alt={`itin-row-${props.id}`} />
      <div className="itin-row-details-container flex-lg-row flex-column align-items-lg-center align-items-start">
        <div>
          <div className="itin-row-name headline mt-md-0 mt-3">
            [Bundling Tiket] Itinerary {props.trip.name}
          </div>
          <div className="itin-row-time">
          Rp {totalBudget}
          </div>
          <p className="see-more">
              <span>Lihat selengkapnya</span>
              <ArrowRightSvg/>
            </p> 
        </div>
  
      </div>
    </div>
  );
}
